import React from "react";

const Spinner = () => {
    return (
        <div className="spinner-container">
            <div className="money-spinner"></div>
        </div>
    );
};

export default Spinner;
